import { NgModule } from '@angular/core';
import { RenderDirective } from './render/render.directive';
import { PressDirective } from './press/press.directive';
import { InViewportDirective } from './viewport.directive';

@NgModule({
  declarations: [RenderDirective, PressDirective, InViewportDirective],
  imports: [],
  exports: [RenderDirective, PressDirective, InViewportDirective],
})
export class DirectivesModule {}
